import moment from "moment";
import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const ConcurrentChart = ({ data }) => {
  const [options, setOptions] = useState({
    responsive: [
      {
        breakpoint: 425,
        options: {
          chart: {
            height: 350,
            width: 300,
          },
        },
      },
      {
        breakpoint: 325,
        options: {
          chart: {
            height: 300,
            width: 250,
          },
        },
      },
    ],
    fill: {
      opacity: 1,
    },
    legend: {
      position: "top", // Position legend at the top
      horizontalAlign: "right",
      fontSize: "14px",
      fontWeight: 700,
      labels: {
        colors: "white",
      },
      markers: {
        width: 15,
        height: 15,
      },
    },
    colors: ["#0D56EB", "#FD504F"],
    chart: {
      fontFamily: "Outfit, sans-serif",
      toolbar: {
        show: false,
      },
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      // curve: "smooth",
      width: 2.5,
    },
    grid: {
      borderColor: "#393939",
      strokeDashArray: 0,
    },
    labels: [],
    xaxis: {
      categories: [],
      tooltip: {
        enabled: false,
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        rotate: -45,
        style: {
          colors: "#8B8E93",
          fontSize: "12px",
        },
      },
    },
    yaxis: [
      {
        seriesName: "Concurrent trades",
        title: {
          text: "",
          style: {
            fontSize: 14,
            fontWeight: 700,
            color: "#ffffff",
          },
        },
        labels: {
          formatter: (value) => Number(value ?? 0).toFixed(0),
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },
      {
        opposite: true,
        seriesName: "Concurrent Lots",
        title: {
          text: "",
          style: {
            fontSize: 14,
            fontWeight: 700,
            color: "#ffffff",
          },
        },
        labels: {
          formatter: (value) => Number(value ?? 0).toFixed(2),
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },
    ],
    tooltip: {
      x: {
        show: true,
      },
      style: {
        fontSize: "14px",
        fontWeight: "700",
      },
      // custom: function ({ series, seriesIndex, dataPointIndex, w }) {
      //   return (
      //     '<div class="arrow_box">' +
      //     '<div class="Annotation-box Date">' +
      //     "<div>" +
      //     "</div>" +
      //     "<span>" +
      //     "</span>" +
      //     "</div>" +
      //     "<div>" +
      //     `<svg width="150" height="1" viewBox="0 0 150 1" fill="none" xmlns="http://www.w3.org/2000/svg">
      //            <line x1="0.5" y1="0.5" x2="149.5" y2="0.5" stroke="url(#paint0_radial_430_8036)" strokeLinecap="round"/>
      //            <defs>
      //            <radialGradient id="paint0_radial_430_8036" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(77.9279 1) rotate(180) scale(77.9279 24238.7)">
      //            <stop offset="0.42336" stopColor="white"/>
      //            <stop offset="1" stopColor="white" stopOpacity="0"/>
      //            </radialGradient>
      //            </defs>
      //            </svg>` +
      //     `</div>` +
      //     '<div class="Annotation-box Green mbb-5">' +
      //     "<div>" +
      //     "Concurrent trades - " +
      //     "</div>" +
      //     "<span>" +
      //     series[0][dataPointIndex] +
      //     "</span>" +
      //     "</div>" +
      //     '<div class="Annotation-box Blue mbb-5">' +
      //     "<div>" +
      //     "Concurrent Lots - " +
      //     "</div>" +
      //     "<span>" +
      //     Number(series[1][dataPointIndex] ?? 0).toFixed(2) +
      //     "</span>" +
      //     "</div>" +
      //     "</div>"
      //   );
      // },
    },
  });

  const [series, setSeries] = useState([
    {
      name: "Concurrent trades",
      type: "line",
      data: [],
    },
    {
      name: "Concurrent Lots",
      type: "line",
      data: [],
    },
  ]);

  useEffect(() => {
    if (data) {
      const formattedDates = data.date
        ? data.date.map((date) => moment(date).format("YYYY.MM.DD HH:mm")) // Format to your desired format
        : [];

      setOptions((prevOptions) => ({
        ...prevOptions,
        xaxis: {
          categories: formattedDates, // Set categories to timestamps
        },
      }));
      setSeries([
        {
          name: "Concurrent trades",
          type: "line",
          data: data.trade ?? [],
        },
        {
          name: "Concurrent Lots",
          type: "line",
          data: data.lots ?? [],
        },
      ]);
    }
  }, [data]);

  const hasData = data && (data.trade?.length > 0 || data.lots?.length > 0);

  return (
    <div id="chart">
      {hasData ? (
        <ReactApexChart options={options} series={series} height={250} />
      ) : (
        <div className="no-data">No Data Available</div>
      )}
    </div>
  );
};

export default ConcurrentChart;
